{
  //prevents reverse tabnapping
  function addNoOpener(link) {
    let linkTypes = (link.getAttribute('rel') || '').split(' ')
    if (!linkTypes.includes('noopener')) {
      linkTypes.push('noopener')
    }
    link.setAttribute('rel', linkTypes.join(' ').trim())
  }

  //informs screen reader users of new tab
  function addNewTabMessage(link) {
    if (link.hasAttribute('aria-label')) {
      let linkAttribute = link.getAttribute('aria-label')
      link.setAttribute('aria-label', linkAttribute + ' (opens in a new tab)')
    } else {
      link.insertAdjacentHTML('beforeend', '<span class="sr-only">(opens in a new tab)</span>');
    }
  }

  //informs screen reader users of new site
  function addNewSiteMessage(link) {
    if (link.hasAttribute('aria-label')) {
      let linkAttribute = link.getAttribute('aria-label')
      link.setAttribute('aria-label', linkAttribute + ' (goes to new website)')
    } else {
      link.insertAdjacentHTML('beforeend', '<span class="sr-only">(goes to new website)</span>');
    }
  }

  //adds SVG link
  function addOutboundSVG(link) {
    link.insertAdjacentHTML('beforeend', '<svg class="outbound-svg" style="width:16px;height:16px" xmlns="http://www.w3.org/2000/svg" viewBox="0 -256 1850 1850" aria-hidden="true" focusable="false"><path d="M1438.373 818.95v320q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h704q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-320q0-14 9-23t23-9h64q14 0 23 9t9 23zm384-864v512q0 26-19 45t-45 19q-26 0-45-19l-176-176-652 652q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l652-652-176-176q-19-19-19-45t19-45q19-19 45-19h512q26 0 45 19t19 45z" fill="currentColor"/></svg>');
  }

  function addMailSVG(link) {
    link.insertAdjacentHTML('beforeend', '<svg class="outbound-svg" style="width:16px;height:16px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"><!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"/></svg>');
  }

  function addPhoneSVG(link) {
    link.insertAdjacentHTML('beforeend', '<svg class="outbound-svg" style="width:16px;height:16px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"><!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"/></svg>');
  }

  function manageLink(link) {
    //this functionality works for the structure subdomain.domain.com where (.com/.org/etc come last) but it won't work for stuff like bbc.co.uk becuase it'll think the domain is "co". 
    const linkDomain = link.hostname.split('.').slice(-2).join('.')
    const windowDomain = window.location.hostname.split('.').slice(-2).join('.')

    if (linkDomain != windowDomain && link.href.indexOf("tel:") == -1 && link.href.indexOf("mailto:") == -1){
      addNoOpener(link)
      addNewSiteMessage(link)
    }
    if (link.getAttribute('target') == '_blank') {
      addNoOpener(link)
      addNewTabMessage(link)
      // if(link.href.indexOf("mailto:") != -1){
      //   addMailSVG(link)
      // } else if(link.href.indexOf("tel:") != -1){
      //   addPhoneSVG(link)
      // } else {
      //   addOutboundSVG(link)
      // }
    }
  }

  function externalLinkHelper() {
    const all_links = document.querySelectorAll('a')
    if (all_links) {
      all_links.forEach(link => {
        if (!link.hasAttribute('ada-link-managed')) {
          link.setAttribute('ada-link-managed', 1)
          manageLink(link)
        }
      })
    }

    //hook into jQuery AJAX and handle links after it loads
    jQuery(document).ajaxComplete(() => setTimeout(externalLinkHelper));
  }

  externalLinkHelper()
}